/**
 * @param date: Date
 * @param locale: string
 * @returns the formatted date based on the locale
 */

type YearFormatType = 'numeric' | '2-digit';

const getFormattedDate = (date: Date, locale: string, yearFormat: YearFormatType = 'numeric') => {
  const fmt = new Intl.DateTimeFormat(locale, {
    month: '2-digit',
    day: '2-digit',
    year: yearFormat,
  });
  return fmt.format(date);
};

export default getFormattedDate;
